var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5488 1.61536H8.61539V3.22213H10.2475V4.31574H8.61539V5.38459H10.2308V6.46151H8.61539V7.53843H10.2308V8.61536H8.61539V9.69228H10.2308V10.7692H8.61539V12.3846H13.5488C13.797 12.3846 14 12.174 14 11.9161V2.08382C14 1.82589 13.797 1.61536 13.5488 1.61536ZM12.9231 10.7692H10.7692V9.69228H12.9231V10.7692ZM12.9231 8.61536H10.7692V7.53843H12.9231V8.61536ZM12.9231 6.46151H10.7692V5.38459H12.9231V6.46151ZM12.9231 4.30766H10.7692V3.23074H12.9231V4.30766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.55562V12.4449L8.07692 14V0L0 1.55562ZM5.10892 9.73538L4.16931 7.959C4.13377 7.89277 4.09715 7.77108 4.05892 7.59392H4.04438C4.02662 7.67738 3.98462 7.80446 3.91838 7.97462L2.97554 9.73538H1.51146L3.24962 7.00862L1.65954 4.28131H3.15431L3.934 5.91662C3.99485 6.04585 4.04923 6.19931 4.09769 6.37646H4.11277C4.14346 6.26985 4.20054 6.11154 4.284 5.901L5.15092 4.28077H6.51969L4.88439 6.98492L6.56546 9.73485L5.10892 9.73538Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFile);
export default __webpack_public_path__ + "static/media/excel-file.0d3ef9eb343546f84357d785878de8f2.svg";
export { ForwardRef as ReactComponent };